import React, { useEffect, useState } from 'react'
import Analytics from 'utils/googleAnalytics'

import { CustomAdContainer, StyledAd, StyledAdLink } from './style'
import { AdFreeTrialStatus, useAdFree, useAdFreeTrialStatus } from 'hooks/adFree'

type Props = {
  className?: string
}

const IMG_URLS: Record<CustomAdType, string> = {
  tcg: 'https://storage.googleapis.com/topdekt-user/ads/tcg_long.jpg',

  tcgHoliday1: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v1.jpg',
  tcgHoliday2: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v2.jpg',
  tcgHoliday3: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v3.jpg',
  tcgHoliday4: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v4.jpg',
  tcgHoliday5: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v5.jpg',

  tcgHoliday2025: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_ad_2025.webp',

  tcgBlackFriday24: 'https://storage.googleapis.com/topdekt-user/ads/tcg_black_friday_24.webp',

  codex: 'https://storage.googleapis.com/topdekt-user/ads/cc.png',
  ch: 'https://storage.googleapis.com/topdekt-user/ads/ch.png',
  chHoliday: 'https://storage.googleapis.com/topdekt-user/ads/ch_holiday.png',
  spellbook: 'https://storage.googleapis.com/topdekt-user/ads/csb.png',

  edhrec: 'https://storage.googleapis.com/topdekt-user/ads/edhrec_ad.png',
  fabrec: 'https://storage.googleapis.com/topdekt-user/ads/archidekt.png',
  spellvoid: 'https://storage.googleapis.com/topdekt-user/ads/archidekt.png',

  archidekt: 'https://storage.googleapis.com/topdekt-user/ads/archidekt.png', // Fallback

  cardsphere1: 'https://storage.googleapis.com/topdekt-user/ads/cardsphere_ad.png',
  cardsphere2: 'https://storage.googleapis.com/topdekt-user/ads/cardsphere_ad_2.png',
  cardsphere3: 'https://storage.googleapis.com/topdekt-user/ads/cardsphere_ad_3.png',

  bolcast: 'https://storage.googleapis.com/topdekt-user/ads/bolcast_ad.png',
  archidektPatreon: 'https://storage.googleapis.com/topdekt-user/ads/archidekt_patreon_ad.png',
  edhrecCast: 'https://storage.googleapis.com/topdekt-user/ads/edhrec_cast_ad.png',
  spellify: 'https://storage.googleapis.com/topdekt-user/ads/spellify_ad.png',

  ckHolidayAd: 'https://storage.googleapis.com/topdekt-user/ads/ck_holiday_ad.jpg',

  cardGamer: 'https://storage.googleapis.com/topdekt-user/ads/Card_Gamer_ads.png',
  comboVoting: 'https://storage.googleapis.com/topdekt-user/ads/Combo_Vote_ad_6.png',

  tcgPlayerDeal: 'https://storage.googleapis.com/topdekt-user/ads/tcg_player_deal_large.webp',

  archidektNewsletter: 'https://storage.googleapis.com/topdekt-user/ads/archidekt_newsletter_desktop.webp',
  czEot: 'https://storage.googleapis.com/topdekt-user/ads/cz_eot_ad.jpg',

  ckSales: 'https://storage.googleapis.com/topdekt-user/ads/ck_sell_ad.webp',

  adFreeTrial: 'https://storage.googleapis.com/topdekt-user/ads/ad_free_trial.webp',
}

const MOBILE_IMG_URLS: Record<CustomAdType, string> = {
  tcg: 'https://storage.googleapis.com/topdekt-user/ads/tcg_mobile.jpg',

  tcgHoliday1: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v1.jpg',
  tcgHoliday2: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v2.jpg',
  tcgHoliday3: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v3.jpg',
  tcgHoliday4: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v4.jpg',
  tcgHoliday5: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_v5.jpg',

  tcgHoliday2025: 'https://storage.googleapis.com/topdekt-user/ads/tcg_holiday_ad_2025.webp',

  tcgBlackFriday24: 'https://storage.googleapis.com/topdekt-user/ads/tcg_black_friday_24.webp',

  codex: 'https://storage.googleapis.com/topdekt-user/ads/cc.png',
  ch: 'https://storage.googleapis.com/topdekt-user/ads/ch.png',
  chHoliday: 'https://storage.googleapis.com/topdekt-user/ads/ch_holiday.png',
  spellbook: 'https://storage.googleapis.com/topdekt-user/ads/csb.png',

  edhrec: 'https://storage.googleapis.com/topdekt-user/ads/edhrec_ad.png',
  fabrec: 'https://storage.googleapis.com/topdekt-user/ads/archidekt.png',
  spellvoid: 'https://storage.googleapis.com/topdekt-user/ads/archidekt.png',

  archidekt: 'https://storage.googleapis.com/topdekt-user/ads/archidekt.png', // Fallback

  cardsphere1: 'https://storage.googleapis.com/topdekt-user/ads/cardsphere_ad.png',
  cardsphere2: 'https://storage.googleapis.com/topdekt-user/ads/cardsphere_ad_2.png',
  cardsphere3: 'https://storage.googleapis.com/topdekt-user/ads/cardsphere_ad_3.png',

  bolcast: 'https://storage.googleapis.com/topdekt-user/ads/bolcast_ad.png',
  archidektPatreon: 'https://storage.googleapis.com/topdekt-user/ads/archidekt_patreon_ad.png',
  edhrecCast: 'https://storage.googleapis.com/topdekt-user/ads/edhrec_cast_ad.png',
  spellify: 'https://storage.googleapis.com/topdekt-user/ads/spellify_ad.png',

  ckHolidayAd: 'https://storage.googleapis.com/topdekt-user/ads/ck_holiday_ad.jpg',

  cardGamer: 'https://storage.googleapis.com/topdekt-user/ads/Card_Gamer_ad_mobile.png',
  comboVoting: 'https://storage.googleapis.com/topdekt-user/ads/Combo_Vote_ad_mobile.png',

  tcgPlayerDeal: 'https://storage.googleapis.com/topdekt-user/ads/tcg_player_deal.webp',

  archidektNewsletter: 'https://storage.googleapis.com/topdekt-user/ads/archidekt_newsletter_mobile.webp',
  czEot: 'https://storage.googleapis.com/topdekt-user/ads/cz_eot_ad.jpg',

  ckSales: 'https://storage.googleapis.com/topdekt-user/ads/ck_sell_ad.webp',

  adFreeTrial: 'https://storage.googleapis.com/topdekt-user/ads/ad_free_trial.webp',
}

const AD_OUTBOUND_LINKS: Record<CustomAdType, string> = {
  tcg: 'http://tcgads.archidecked.com',

  tcgHoliday1: 'http://partner.tcgplayer.com/c/4913290/1897075/21018',
  tcgHoliday2: 'http://partner.tcgplayer.com/c/4913290/1897076/21018',
  tcgHoliday3: 'http://partner.tcgplayer.com/c/4913290/1897077/21018',
  tcgHoliday4: 'http://partner.tcgplayer.com/c/4913290/1897078/21018',
  tcgHoliday5: 'http://partner.tcgplayer.com/c/4913290/1897079/21018',

  tcgHoliday2025:
    'https://partner.tcgplayer.com/c/4913290/1830156/21018?partnerpropertyid=5237567&subId1=archidekt%2Cblackfriday',

  tcgBlackFriday24: 'https://partner.tcgplayer.com/09Z2RL',

  codex: 'https://commandercodex.com/',
  ch: 'https://commandersherald.com/',
  chHoliday: 'https://commandersherald.com/tag/mtg-2023-gift-guide/',
  spellbook: 'https://commanderspellbook.com/',

  edhrec: 'https://edhrec.com/',
  fabrec: 'https://fabrec.com/',
  spellvoid: 'https://spellvoid.com/',

  archidekt: 'https://archidekt.com/', // Fallback

  cardsphere1: 'https://www.cardsphere.com/',
  cardsphere2: 'https://commandersherald.com/selling-your-magic-cards-with-cardsphere/',
  cardsphere3: 'https://www.cardsphere.com/',

  bolcast: 'https://www.youtube.com/@AmITheBolcast',
  archidektPatreon: 'https://www.patreon.com/archidekt',
  edhrecCast: 'https://youtube.com/@EDHRECast',
  spellify: 'https://commandersherald.com/games/spellify/',

  ckHolidayAd:
    'http://www.cardkingdom.com/landing/mtg-dual-lands?partner=archidekt&utm_source=archidekt&utm_medium=affiliate&utm_campaign=archidekt&partner_args=holiday-2024',

  cardGamer: 'https://cardgamer.com/',
  comboVoting: 'https://edhrec.com/combo-vote?utm_source=archidekt',

  tcgPlayerDeal: 'https://partner.tcgplayer.com/c/4913290/2870693/21018',

  archidektNewsletter: 'https://archidekt.com/accountSettings/notification-settings',
  czEot: 'https://youtu.be/jclO7Mjfjq0',

  ckSales:
    'https://www.cardkingdom.com/purchasing/how_to_sell?partner=EDHRECSell&utm_source=edhrec&utm_medium=affiliate&utm_campaign=edhrec&partner_args=archidekt-adhesion',

  adFreeTrial: '/accountSettings/account-details',
}

// @ts-ignore
const MOBILE_AD_OUTBOUND_LINKS: Record<Partial<CustomAdType>, string> = {
  tcgPlayerDeal: 'https://partner.tcgplayer.com/c/4913290/2870695/21018',
}

// @ts-ignore
const CUSTOM_DESKTOP_HEIGHT: Record<Partial<CustomAdType>, number> = {
  tcgPlayerDeal: 225,
}

export const getAdInfo = (skippableAds: Array<CustomAdType> = [], adFreeStatus?: AdFreeTrialStatus): CustomAdInfo => {
  const adPool: CustomAdType[] = []

  // Forced override code unused at this time
  const now = new Date()
  const forceOverrideAdStartTime = new Date('2026-04-09T00:00:00Z')
  const forceOverrideAdEndTime = new Date('2026-04-13T05:00:00Z')

  const isForceOverrideAdTime = now >= forceOverrideAdStartTime && now <= forceOverrideAdEndTime

  if (isForceOverrideAdTime)
    return {
      adType: 'comboVoting',

      adUrl: IMG_URLS['comboVoting'],
      adMobileUrl: MOBILE_IMG_URLS['comboVoting'],

      adHref: AD_OUTBOUND_LINKS['comboVoting'],
      adMobileHref: MOBILE_AD_OUTBOUND_LINKS['comboVoting'],
    }

  if (adFreeStatus === 'NOT_STARTED' && !skippableAds.includes('adFreeTrial')) adPool.push('adFreeTrial')

  if (!skippableAds.includes('ckSales')) adPool.push('ckSales')
  if (!skippableAds.includes('archidektPatreon')) adPool.push('archidektPatreon')
  if (!skippableAds.includes('cardsphere3')) adPool.push('cardsphere3')

  // if (!skippableAds.includes('archidektNewsletter')) adPool.push('archidektNewsletter')
  // if (!skippableAds.includes('czEot')) adPool.push('czEot')
  // if (!skippableAds.includes('spellify')) adPool.push('spellify')
  // if (!skippableAds.includes('edhrec')) adPool.push('edhrec')
  // if (!skippableAds.includes('ch')) adPool.push('ch')
  // if (!skippableAds.includes('edhrecCast')) adPool.push('edhrecCast')
  // if (!skippableAds.includes('bolcast')) adPool.push('bolcast')
  // if (!skippableAds.includes('spellbook')) adPool.push('spellbook')
  // if (!skippableAds.includes('comboVoting')) adPool.push('comboVoting')
  // if (!skippableAds.includes('archidektPatreon')) adPool.push(...Array(3).fill('archidektPatreon'))

  // if (!skippableAds.includes('tcg')) adPool.push(...Array(adPool.length).fill('tcg')) // Fills the array with tcg to account for 50% of the ads (aka the same amount as all other ads combined)

  const chosenAd = adPool[Math.floor(Math.random() * adPool.length)]

  return {
    adType: chosenAd,
    adHref: AD_OUTBOUND_LINKS[chosenAd],
    adUrl: IMG_URLS[chosenAd],
    adMobileUrl: MOBILE_IMG_URLS[chosenAd],
  }
}

type CustomAdType =
  | 'tcg'
  | 'edhrec'
  | 'ch'
  | 'fabrec'
  | 'spellvoid'
  | 'codex'
  | 'spellbook'
  | 'archidekt'
  | 'chHoliday'
  | 'tcgHoliday1'
  | 'tcgHoliday2'
  | 'tcgHoliday3'
  | 'tcgHoliday4'
  | 'tcgHoliday5'
  | 'tcgHoliday2025'
  | 'tcgBlackFriday24'
  | 'cardsphere1'
  | 'cardsphere2'
  | 'cardsphere3'
  | 'bolcast'
  | 'archidektPatreon'
  | 'edhrecCast'
  | 'spellify'
  | 'ckHolidayAd'
  | 'cardGamer'
  | 'comboVoting'
  | 'tcgPlayerDeal'
  | 'archidektNewsletter'
  | 'czEot'
  | 'ckSales'
  | 'adFreeTrial'

export type CustomAdInfo = {
  adType: CustomAdType
  adHref: string
  adUrl: string
  adMobileUrl: string

  adMobileHref?: string
  adCustomDesktopHeight?: number
}

const CustomAd = ({ className = '' }: Props) => {
  const [chosenAd, setChosenAd] = useState<CustomAdInfo | null>(null)
  const [adFreeStatus] = useAdFreeTrialStatus()

  useEffect(() => {
    const ad = getAdInfo([], adFreeStatus)

    Analytics.signalEvent('Rendered custom ad TOTAL')
    Analytics.signalEvent(`Rendered custom ad ${ad.adType}`)

    setChosenAd(ad)
  }, [])

  const handleLogAdClick = () => {
    Analytics.signalEvent(`Clicked ${chosenAd?.adType} ad`)
  }

  const adFree = useAdFree()
  const internalLink = (chosenAd?.adHref || '')[0] === '/'

  if (adFree || !chosenAd) return null

  return (
    <CustomAdContainer className={className}>
      <StyledAdLink
        href={chosenAd.adHref}
        target={internalLink ? undefined : '_blank'}
        rel={internalLink ? undefined : 'noopener noreferrer'}
        onClick={handleLogAdClick}
        style={{ height: chosenAd.adCustomDesktopHeight }}>
        <StyledAd
          url={chosenAd.adUrl}
          mobileUrl={chosenAd.adMobileUrl}
          style={{ height: chosenAd.adCustomDesktopHeight }}
        />
      </StyledAdLink>
    </CustomAdContainer>
  )
}

export default CustomAd
